import { Token } from '@daas-consulting/security/authentication/frontend/models';
import { Observable } from 'rxjs';

export const AuthenticationServiceId =
  'security.authentication.AuthenticationService';

export interface AuthenticationService {
  generateQrCode$(userId: string): Observable<string>;
  loginWithCode$(code: string): Observable<Token>;
  turnOn$(userId: string, code1: string, code2: string): Observable<void>;
  validate2fa$(userId: string, code: string): Observable<Token>;
}
